import { createSlice } from '@reduxjs/toolkit';
import { randomId } from '@mui/x-data-grid-generator';

const presetNoteSlice = createSlice({
    name: 'presetNoteForm',
    initialState: [],
    reducers: {
        setPresetNote: (state, action) => {
            return action.payload;
        },
        /** Reducer for creating empty note object with randomId. */
        addPresetNoteContent: (state, action) => {
            const { index, attribute, content, preset_table_id } = action.payload;
            const newPresetNote = {
                id: randomId(),
                shipment_type: index,
                il_preset_id: preset_table_id,
                attribute: attribute,
                value: content,
            };
            state.push(newPresetNote);
        },
        /** Reducer for updating the selected trade partner's note list after an emit event. (Currently not in use) */
        updatePresetNote: (state, action) => {
            const { presetNoteForm, il_trade_partner } = action.payload;

            const makeKey = (item) => `${item.shipment_type}|${item.il_preset_id}|${item.attribute}`;

            const newNoteMap = new Map();
            presetNoteForm.forEach((note) => {
                const key = makeKey(note);
                newNoteMap.set(key, note);
            });

            const updatedState = state.map((oldNote) => {
                const key = makeKey(oldNote);
                if (newNoteMap.has(key)) {
                    const newNote = newNoteMap.get(key);
                    newNoteMap.delete(key);
                    return newNote;
                }
                return oldNote;
            });

            const newNotesToAdd = Array.from(newNoteMap.values()).map((note) => ({ ...note }));

            return [...updatedState, ...newNotesToAdd];
        },
        /** Reducer for updating note content. */
        updatePresetNoteContent: (state, action) => {
            const targetNote = action.payload;

            // Find updated note from state.
            const note = state.find((n) => n.id === targetNote.id);
            // Override the updated note if note is found.
            if (note) {
                Object.assign(note, targetNote);
            }
        },
        clearPresetNote: (state, action) => {
            return [];
        },
    },
});

export const { setPresetNote, addPresetNoteContent, updatePresetNote, updatePresetNoteContent, clearPresetNote } =
    presetNoteSlice.actions;
export default presetNoteSlice.reducer;
